/* eslint-disable camelcase */
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from 'controllers/network/apiClient';
import useAuth from 'hooks/useAuth';

export const SUBSCRIBER_STATUS_CACHE_KEY = 'subscriberStatus';
export const SUBSCRIBER_STATUS_URL = '/v2/shops/merchant-opted-in';

type UseSubscriberStatusInstance = UseQueryResult<boolean>;

export const getSubscriberStatus = async (): Promise<boolean> => {
  const { opted_in } = await api.get(SUBSCRIBER_STATUS_URL);

  return opted_in;
};

export const useSubscriberStatus = (): UseSubscriberStatusInstance => {
  const { isHistorySession } = useAuth();
  return useQuery<boolean>({
    queryKey: [SUBSCRIBER_STATUS_CACHE_KEY, isHistorySession],
    enabled: !isHistorySession,
    queryFn: () => (isHistorySession ? false : getSubscriberStatus()),
  });
};
